export default {"src":"/_next/static/media/phone-menu-violite.23c88542.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};